const asideActionGlobal = {
  current: (
    _action: React.ReactNode | null,
    _options?: {
      isWide?: boolean
      position?: 'sidebar' | 'bottom' | 'modal'
      availablePositions?: ('sidebar' | 'bottom' | 'modal')[]
    }
  ) => true
}

export const getAsideActionGlobalRef = (): typeof asideActionGlobal =>
  asideActionGlobal
